import React from "react";
import InfoTag from "../../Components/SendMoney/InfoTag";
import {
  BENEFICIARY_ADDED_MESSAGE,
  TAG_INFO,
} from "../../Utils/Contant";

const ShieldClockIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 3 4 6v6c0 4.5 3.4 8.3 8 9 4.6-.7 8-4.5 8-9V6l-8-3Z" />
    <path d="M12 9v3.2l2 1.2" />
  </svg>
);

function BeneficiaryAdded({ beneficiary }) {
  const method = (
    beneficiary?.method ||
    beneficiary?.beniConfigCountry?.method ||
    ""
  ).toUpperCase();

  return (
    <div className="flex flex-col items-center text-center pt-8 sm:pt-12 pb-6 px-2">
      <div className="h-24 w-24 rounded-full bg-[#FDF3E4] text-[#B5651D] flex items-center justify-center mb-6">
        <ShieldClockIcon />
      </div>
      <h3 className="text-2xl font-geomanistBold text-blackShade mb-3">
        Beneficiary added
      </h3>
      <p className="text-sm leading-6 font-geomanistRegular text-greyish mb-8">
        {BENEFICIARY_ADDED_MESSAGE}
      </p>

      <div className="w-full rounded-xl border border-LightGreyBorder bg-white p-4 flex items-center justify-between gap-3 text-left">
        <div className="min-w-0">
          <p
            className="font-geomanistBold text-blackShade text-sm truncate"
            title={beneficiary?.nameOfBeni}
          >
            {beneficiary?.nameOfBeni}
          </p>
          <p className="mt-0.5 text-xs">
            <span className="font-geomanistBold text-blackShade">
              {beneficiary?.maskAccountNo || beneficiary?.iban}
            </span>
            <span className="pl-1.5 text-greyish font-geomanistRegular">
              {beneficiary?.bankName}
            </span>
          </p>
        </div>
        {method && (
          <InfoTag
            label={method}
            info={TAG_INFO[method] || TAG_INFO.MANUAL_REVIEW}
          />
        )}
      </div>
    </div>
  );
}

export default BeneficiaryAdded;
